import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { take } from 'rxjs';
import { ExportsService } from 'src/app/services/exports.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { AppUtils } from 'src/app/shared/app.utils';
import { ExportType } from 'src/app/shared/types/export.types';

@Component({
  selector: 'ness-exports-grid',
  templateUrl: './exports-grid.component.html'
})
export class ExportsGridComponent {
  cols: any[] = [
    { field: 'ExportType.ExportTypeName', header: 'Export type' },
    { field: 'ENESS_CrimeGunNumbers.CrimeGunNumber', header: 'Crime Gun ID' },
    { field: 'Status', header: 'Status' },
    { field: 'GeneratedOn', header: 'Generated date/time' },
    { field: 'ExpiresOn', header: 'Expiration date/time' }
  ];
  @Input() exports: ServerModels.ENESS_Exports[] = [];
  @Output() refreshExports = new EventEmitter();
  rows: number = AppConstants.defaultTableRows;

  constructor(private exportsService: ExportsService) { }

  public downloadExport(item: ServerModels.ExportViewModel): void {
    if (!item || !item.ExportID)
      return;
    this.exportsService.getExportDataById(item.ExportID, this.generateCSVFilename(item)).pipe(take(1)).subscribe((response: HttpResponse<Blob>) => {
        let contentDisposition = response.headers.get('content-disposition');
        let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');
        AppUtils.embedDownloadLink(response.body, filename);
      },
      (err: any) => {
        console.log(err);
      });
  }

  public generateCSVFilename(exportResult: ServerModels.ExportViewModel): string {
    switch (<ExportType>exportResult.ExportTypeName) {
      case 'Crime Gun Step Out':
        return `CrimeGun-${exportResult.CrimeGunNumber}-StepOut${exportResult.NumberOfSteps}Export.csv`;
      case 'NIBIN Ballistic Evidence':
        return `NIBINBallisticEvidence${this.formatFDName(exportResult.FieldDivisionName)}${moment(exportResult.StartDate).format('MMDDYYYY')}-${moment(exportResult.EndDate).format('MMDDYYYY')}.csv`;
      case 'Crime Gun Overview':
        return `CrimeGunOverview${this.formatFDName(exportResult.FieldDivisionName)}${moment(exportResult.StartDate).format('MMDDYYYY')}-${moment(exportResult.EndDate).format('MMDDYYYY')}.csv`;
      default:
        return exportResult.ExportTypeName.replace(/\s+/g, '') + 'Export.csv';
    };
  }

  public formatFDName(fieldDivisionName: string): string {
    if (fieldDivisionName == "All") {
      return "AllFD";
    }
    return fieldDivisionName.replace(' ', '')
  }
}
